import request from '@/utils/request'

export function pager(data) {
  return request({
    url: '/api/estimateBase/pager',
    method: 'post',
    params: data,
  })
}

export function getEstimateDetail(data) {
  return request({
    url: '/api/getEstimateListById',
    method: 'post',
    data,
  })
}
export function getEstimateBasicInfo(data) {
  return request({
    url: '/api/estimateBase',
    method: 'get',
    params: data,
  })
}

// 見積登録
export function postEstimateBase(data) {
  return request({
    url: '/api/estimateBase',
    method: 'post',
    data,
  })
}

//内訳
export function getEstimateBreakDown() {
  return request({
    url: '/api/estimateBreakdown/list',
    method: 'get',
  })
}
//内訳明細
export function getEstimateBreakDownDetails() {
  return request({
    url: `/api/getEstimateBreakDownDetails`,
    method: 'get',
  })
}

//内訳明細
export function getEstimateBasic() {
  return request({
    url: '/api/estimateBasic',
    method: 'get',
  })
}

export function getESTPRKBList() {
  return request({
    url: '/data/getESTPRKBList',
    method: 'post',
  })
}

export function getOverviewData() {
  return request({
    url: '/api/overviewData',
    method: 'get',
  })
}

export function getRateList() {
  return request({
    url: '/data/getRateList',
    method: 'post',
  })
}
